import { apiSlice } from "features/api/apiSlice";
import { transformVoucher } from "./transformVoucher";

const getVouchers = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getVouchers: build.query({
      query: ({ user, type, doctor }) => {
        const params = new URLSearchParams({
          appointmentUsage: type,
          doctorId: doctor,
        });

        return `/vouchers/usable/${user}?${params}`;
      },
      transformResponse: (res) => res.d.usableVouchers.map(transformVoucher),
      providesTags: ["Voucher"],
    }),
  }),
});

export const { useGetVouchersQuery } = getVouchers;
